export default function SearchIcon ({
    style,
    fill="#83CFA4",
}){
    return <svg style={style} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.73273 17.0267C13.0818 17.0267 16.6074 13.5011 16.6074 9.15202C16.6074 4.80295 13.0818 1.27734 8.73273 1.27734C4.38367 1.27734 11.426 3.47509 11.8601 9.15202C12.3077 15.0058 4.38367 17.0267 8.73273 17.0267Z" fill={fill} />
    <path d="M8.73405 17.0267C13.0831 17.0267 16.6087 13.5011 16.6087 9.15202C16.6087 4.80295 13.0831 1.27734 8.73405 1.27734C4.38499 1.27734 0.859375 4.80295 0.859375 9.15202C0.859375 13.5011 4.38499 17.0267 8.73405 17.0267Z" stroke="#536987" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14.3047 14.7207L18.8607 19.2768" stroke="#536987" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
}
